/**
 * Method: GET
 */
import { TypeInt } from "./common/TypeInt";
import { OutputBase } from "./common/OutputBase";
import { InputBase } from "./common/InputBase";

export class InverterPlanGetInput extends InputBase {
	id: number;
}

export class InverterPlanGetOutput extends OutputBase {
	ok: {
		data: InverterPlanGetData
	}
	error: {
	}
}

export class InverterPlanGetData {
	id: number;
	projectID: number;
	panelID: number;
	panelCount: number;
	cosPhi: number;
	dimensionMin: number;
	dimensionMax: number;
	inverterGroups: {
		id: number,
		name: string,
	}[];
	subGenerators: InverterPlanGetSubGenerator[];
	/**
	 * AC/DC components
	 */
	panelConnector: boolean;
	dcSurgeProtectID: string;

	invalid: boolean;
	updated: string;
}

export class InverterPlanGetSubGenerator {
	name: string;
	color: string;
	inverterID: number;
	panelCount: number;
	dcCableLength: number;
	strings: InverterPlanGetStrings[];
	mppt: InverterPlanGetMPPT[];
}

export class InverterPlanGetStrings {
	name: string;
	color: string;
	panelCount: number;
	nodes: {
		panelRowID: number,
		panelIndex: number,
		nodeIndex: number,
	}[];
}

export class InverterPlanGetMPPT {
	trackerIndex: number;
	stringCount: number;
	panelCountPerString: number;
}